import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./lib/lang";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Services } from "./components/site/Services";
import { MenuBento } from "./components/site/MenuBento";
import { WhyUs } from "./components/site/WhyUs";
import { Faq } from "./components/site/Faq";
import { MobileBar } from "./components/site/Footer";
import { HoursSection } from "./components/site/HoursSection";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "./pages/AdminPage";
import { HolidayBanner, useHolidayBanner, BANNER_H } from "./components/site/HolidayBanner";

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);
};

function Site() {
  const banner = useHolidayBanner();
  return (
    <div className="App grain">
      <div aria-hidden className="site-bg" style={{ backgroundImage: "linear-gradient(rgba(246,230,214,0.86), rgba(244,226,210,0.92)), url('/food/courtyard-blur.jpg')" }} />
      <HolidayBanner banner={banner} />
      <Nav offset={banner.visible ? BANNER_H : 0} />
      <main>
        <Hero />
        <Services />
        <MenuBento />
        <WhyUs />
        <HoursSection />
        <Faq />
      </main>
      <MobileBar />
    </div>
  );
}

function App() {
  useLenis();
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LangProvider>
  );
}

export default App;
